 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"27cc93d0ecd8ad0b5457b78d74aa12ad3612cc1e","1":"bac1b955","4":"component---src-accessibility-statement-mdx","5":"component---src-change-language-mdx","6":"component---src-click-collect-mdx","7":"component---src-configure-a-gps-location-mdx","8":"component---src-configure-account-push-notifications-mdx","9":"component---src-configure-ad-hoc-push-notifications-mdx","10":"component---src-configure-app-authentication-mdx","11":"component---src-configure-barcode-self-check-mdx","12":"component---src-configure-click-collect-mdx","13":"component---src-configure-dynamic-tabs-mdx","14":"component---src-configure-minimum-app-version-mdx","15":"component---src-configure-patron-account-options-mdx","16":"component---src-configure-rfid-self-check-mdx","17":"component---src-configure-stripe-payments-mdx","18":"component---src-configure-ui-colors-mdx","19":"component---src-create-a-content-item-mdx","20":"component---src-create-a-self-service-tab-mdx","21":"component---src-create-a-tab-mdx","22":"component---src-create-a-user-mdx","23":"component---src-create-dynamic-home-tabs-mdx","24":"component---src-creating-channels-video-mdx","25":"component---src-creating-content-video-mdx","26":"component---src-creating-users-video-mdx","27":"component---src-customize-highlights-on-home-screen-mdx-md","28":"component---src-delete-a-channel-mdx","29":"component---src-delete-a-content-item-mdx","30":"component---src-delete-a-content-items-schedule-mdx","31":"component---src-delete-a-tab-mdx","32":"component---src-delete-a-user-mdx","33":"component---src-edit-a-channel-mdx","34":"component---src-edit-a-mobile-app-mdx","35":"component---src-edit-a-tab-mdx","36":"component---src-edit-languages-mdx","37":"component---src-edit-the-home-screen-tab-mdx","38":"component---src-faq-mdx","39":"component---src-generate-an-activity-report-mdx","40":"component---src-getting-started-mdx","41":"component---src-helpful-apple-links-mdx","42":"component---src-link-content-to-a-tab-mdx","43":"component---src-linked-accounts-mdx","44":"component---src-my-lists-mdx","45":"component---src-navigation-tutorial-video-mdx","46":"component---src-notifications-mdx","47":"component---src-open-the-staff-dashboard-mdx","48":"component---src-organize-tabs-mdx","49":"component---src-pages-404-js","50":"component---src-pin-a-tab-mdx","51":"component---src-privacy-policy-mdx","52":"component---src-reading-tracker-awards-mdx","53":"component---src-reading-tracker-delete-reviews-mdx","54":"component---src-reading-tracker-mdx","55":"component---src-reading-tracker-reviews-mdx","56":"component---src-releases-mdx","57":"component---src-schedule-a-content-item-mdx","58":"component---src-supported-devices-operating-systems-mdx","59":"component---src-supported-vendors-mdx"}[chunkId]||chunkId) + "-" + {"0":"5341067d6077e74fc231","1":"0612ca16fb758ff9b3ea","4":"2d3eacea4fd5f3ea7741","5":"dad666dd6d469c6b8e7d","6":"6cd3df7025016c8c9983","7":"fdd537cf9108ab4b2a06","8":"8d8ecf71b91fc27e6b2e","9":"2dcb1a795797c39a62bb","10":"791eedf6853dd42fd367","11":"362ee9ef1e9fb003b67a","12":"ccd199e7637186f6aca1","13":"af3173ec3a090c356f40","14":"900300db3f73a8070785","15":"be113d6858517b611037","16":"551a3cc84e7f778d6215","17":"401ebbb2073804372edd","18":"b7b817d667f0c9bea177","19":"bcdcb38bcaebf886c57a","20":"4cf7ecca94e1051db688","21":"d97ccc04ffc7972258b5","22":"ee237f18c82b629710c4","23":"a8416ef905731d44bf11","24":"d243ff3781130344e269","25":"88b69ba80147454c2dab","26":"9cce39b77895b47dada6","27":"d613224faa39e2c95e05","28":"e6b1ae4f7b78789335d5","29":"9af2e7f5a053a57b7a61","30":"329f521da143cda1534a","31":"55039f94f0cbd0bee464","32":"4558388b9a58c4091ae9","33":"76d2035d960c67ed078a","34":"d63d8e2dc34c10c6cdd2","35":"ac4da2c36a8a90b84153","36":"5731e47a42411d5cfbea","37":"174b1d7f85d45403008b","38":"a170668c11e498e06b43","39":"3e4f72b39957dd49a530","40":"536003afabee24a9e48a","41":"8dd60de868d92962571e","42":"21d690937d398278ac86","43":"a2ab6f4838d4cf1c1f30","44":"aa878e8accaba371c4c7","45":"caa9491fab3074d1ebb7","46":"a235d09f405e94848af6","47":"1a2670c286f9f07a8bac","48":"66bee9f8e047425f52d5","49":"8a34e0a32f7bd14041c0","50":"c60dd153a20c5204bbbe","51":"c291784d9edd047048ff","52":"83b9500bc68c2b7b0b15","53":"d232bae9b4c674b4af52","54":"128f3c96487ad2fc2c48","55":"0487f17548395a1b9aaf","56":"f7a034ef52156107391a","57":"040ab971642d69a07da1","58":"5613a59d4fa7d39f90d9","59":"117889a83c38e652cc65"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
